// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderLocation":"c-k_gN","advertDetailHeaderLocation__value":"c-k_gO"};